import { render, staticRenderFns } from "./first-registration.vue?vue&type=template&id=d3f08f4e&scoped=true&"
import script from "./first-registration.vue?vue&type=script&lang=js&"
export * from "./first-registration.vue?vue&type=script&lang=js&"
import style0 from "./first-registration.vue?vue&type=style&index=0&id=d3f08f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f08f4e",
  null
  
)

export default component.exports